/**
 * @ngdoc service
 * @name gazelle.components.validation.service:$gzRegexValidator
 *
 * @description
 * `$gzRegexValidator` allows for validating values against model regex validators.
 */
export const name = '$gzRegexValidator';
export default function $gzRegexValidator(rnHttp, $q, $window) {
  'ngInject';

  var service = {
    validate: validate,
  };
  return service;

  ////////////////////

  /**
   * @ngdoc function
   * @name validate
   * @name gazelle.components.validation.service:$gzRegexValidator
   * @description validates a value against a regex validator
   * @param {string} regexValidatorProperty name of the regex validator property to retrieve the regex to validate with
   * @param {string} value to validate
   */
  function validate(regexValidatorProperty, value) {
    return getValidator(regexValidatorProperty)
      .then(validator => {
        let regex = new $window.XRegExp(validator.validation, validator.validationFlags);
        if(!regex.test(value)) {
          return $q.reject(`Validator "${validator.validationId}" rejected value "${value}"`);
        }
        return true;
      });
  }

  function getValidator(validatorProperty) {
    return rnHttp.get('portal_service', 'validation', {cache: true})
      .then(response => {
        let allValidators = response.data;
        let validator = _.find(allValidators, 'validationId', validatorProperty);
        if(validator === undefined) {
          return $q.reject('Unable to find validator ' + validator);
        }
        return validator;
      });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/regexValidator.service.js